import { initConfig } from '@cian/config/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { initHttpApi } from '@cian/http-api/browser';
import { initLogger } from '@cian/logger/browser';
import { initTelemetry } from '@cian/telemetry/browser';
import { init as initWeb } from '@cian/web/browser';

export function initDependencies() {
  initConfig();
  initLogger();
  initTelemetry();
  initHttpApi();
  initWeb();
  initGlobalBehaviors();
}
